module.exports = __webpack_public_path__ + "static/img/va.0b05f974.svg";